import React from "react";
import { Button, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import { makeStyles } from "@mui/styles";
import historyIcon from "../../../assets/images/file-upload-icon.svg";

interface FileUploadProps {
  name: string;
  label: string;
  control: any;
  errors: any;
  isDisabled?: boolean;
  onFileChange: (file: File | undefined) => void;
  isProjectUpload?: boolean;
}

const useStyles = makeStyles({
  browseButton: (props: { isProjectUpload?: boolean }) => ({
    backgroundColor: props.isProjectUpload ? "#2a3fbf !important" : "#d9d9d9 !important",
    border: "1px solid #626262",
    color: props.isProjectUpload ? "white !important" : "#626262 !important",
    padding: "7px 30px",
    fontWeight: "700",
    "&:hover": {
      backgroundColor: props.isProjectUpload ? "#2a3fbf !important" : "#d9d9d9 !important",
      color: props.isProjectUpload ? "white !important" : "#626262 !important",
    },
  }),
});

const FileUpload: React.FC<FileUploadProps> = ({
  name,
  label,
  control,
  errors,
  onFileChange,
  isDisabled = false,
  isProjectUpload = false,
}) => {
  const classes = useStyles({ isProjectUpload });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <Button
            variant="contained"
            component="label"
            sx={{
              borderRadius: "30px",
              boxShadow: "0",
              px: 4,
              py: 1,
              textTransform: "capitalize",
            }}
            className={classes.browseButton}
          >
            {isProjectUpload ? <img src={historyIcon} className="height-auto history-icon" /> : null}
            {label}
            <input
              type="file"
              hidden
              disabled={isDisabled}
              accept={isProjectUpload ? "application/*" : "image/*"}
              onChange={(e) => {
                const file = e.target.files?.[0];
                field.onChange(file);
                onFileChange(file);
                e.target.value = ""
              }}
            />
          </Button>
          {errors[name] && (
            <Typography color="error">{errors[name]?.message}</Typography>
          )}
        </>
      )}
    />
  );
};

export default FileUpload;
